import { ArrowUpRight, Clock3, Globe, Instagram, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { company } from "../config/company";
import "./SiteFooter.css";

export const SiteFooter = () => (
  <footer className="site-footer" data-testid="site-footer" aria-label="Informasi perusahaan dan kontak">
    <div className="site-footer-main">
      <section className="site-footer-company" aria-label="Tentang MASES Bangunan">
        <div className="site-footer-brand" data-testid="footer-company-brand">
          <span className="brand-mark" aria-hidden="true">M</span>
          <span>MASES<span className="site-footer-brand-sub">BANGUNAN</span></span>
        </div>
        <p className="site-footer-legal" data-testid="footer-company-legal-name">{company.legalName}</p>
        <p data-testid="footer-company-description">{company.description}</p>
      </section>

      <section aria-labelledby="footer-office-heading">
        <h2 id="footer-office-heading" data-testid="footer-office-heading">Kantor pusat</h2>
        <address className="site-footer-address">
          <MapPin size={18} aria-hidden="true" />
          <span data-testid="footer-company-address">{company.address}</span>
        </address>
        <a className="site-footer-map-link" href={company.mapsUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-maps-link">
          Lihat di Google Maps <ArrowUpRight size={15} aria-hidden="true" />
        </a>
      </section>

      <section aria-labelledby="footer-contact-heading">
        <h2 id="footer-contact-heading" data-testid="footer-contact-heading">Hubungi kami</h2>
        <div className="site-footer-contact-list">
          <a href={`tel:${company.phone}`} data-testid="footer-phone-link"><Phone size={17} aria-hidden="true" /><span>{company.phoneDisplay}</span></a>
          <a href={`mailto:${company.email}`} data-testid="footer-email-link"><Mail size={17} aria-hidden="true" /><span>{company.email}</span></a>
        </div>
        <a className="site-footer-whatsapp" href={company.whatsappUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link">
          <MessageCircle size={18} aria-hidden="true" /> Chat via WhatsApp <ArrowUpRight size={16} aria-hidden="true" />
        </a>
      </section>

      <section aria-labelledby="footer-hours-heading">
        <h2 id="footer-hours-heading" data-testid="footer-hours-heading">Jam layanan</h2>
        <div className="site-footer-hours"><Clock3 size={18} aria-hidden="true" /><p data-testid="footer-operating-hours">{company.workingDays}<strong>{company.workingHours}</strong></p></div>
        <p className="site-footer-after-hours" data-testid="footer-after-hours-note">Layanan darurat di luar jam kerja melalui WhatsApp.</p>
      </section>
    </div>

    <div className="site-footer-bottom">
      <p data-testid="footer-copyright">© {new Date().getFullYear()} {company.legalName}. Hak cipta dilindungi.</p>
      <div className="site-footer-socials">
        <a href={company.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"><Instagram size={17} aria-hidden="true" /><span>mases.bangunan</span><ArrowUpRight size={14} aria-hidden="true" /></a>
        <a href={company.websiteUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-website-link"><Globe size={17} aria-hidden="true" /><span>masesbangunan.com</span><ArrowUpRight size={14} aria-hidden="true" /></a>
      </div>
    </div>
  </footer>
);